/**
 * General signing interface, can be used for in memory signing, RPC singing, external wallet, HSM, etc.
 */
export class Signer {
}
